import client from "./client";

export const myProfile = async () => (await client.get("/profile/me")).data;

export const saveMyProfile = async (body) => (await client.put("/profile/me", body)).data;
